import React from 'react';
import {Link} from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import californiaLocations from '../data/californiaLocations';

const {FiMail,FiMapPin,FiFacebook,FiTwitter,FiLinkedin}=FiIcons;

const Footer=()=> {
// Get main cities for footer display
const mainCities=Object.entries(californiaLocations).slice(0,12);

return (
<footer className="bg-gray-900 text-white">
<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
{/* Company Info */}
<div>
<div className="flex items-center space-x-3 mb-4">
<div className="flex items-center space-x-2">
<img
src="https://app1.sharemyimage.com/2025/05/19/burbank-insurance-services-in-california-logo.png"
alt="Burbank Insurance Services"
className="h-8 w-auto bg-white rounded p-1"
/>
<span className="text-blue-400 font-bold">+</span>
<img
src="https://cdn1.sharemyimage.com/smi/2025/09/13/nw-logo.png"
alt="Nationwide Insurance"
className="h-6 w-auto bg-white rounded p-1"
/>
</div>
</div>
<div className="font-bold text-lg mb-2">Partnership for Pet Protection</div>
<p className="text-gray-300 mb-4">
Authorized Nationwide pet insurance agent serving all of California. Protecting your pets with comprehensive coverage since 2010.
</p>
<div className="flex space-x-4">
<SafeIcon icon={FiFacebook} className="h-5 w-5 text-gray-400 hover:text-white cursor-pointer" />
<SafeIcon icon={FiTwitter} className="h-5 w-5 text-gray-400 hover:text-white cursor-pointer" />
<SafeIcon icon={FiLinkedin} className="h-5 w-5 text-gray-400 hover:text-white cursor-pointer" />
</div>
</div>

{/* Quick Links */}
<div>
<h3 className="font-semibold text-lg mb-4">Quick Links</h3>
<ul className="space-y-2">
<li><Link to="/" className="text-gray-300 hover:text-white">Home</Link></li>
<li><Link to="/compare" className="text-gray-300 hover:text-white">Compare Plans</Link></li>
<li><Link to="/blog" className="text-gray-300 hover:text-white">Pet Insurance Blog</Link></li>
<li><a href="#" className="text-gray-300 hover:text-white">Privacy Policy</a></li>
<li><a href="#" className="text-gray-300 hover:text-white">Terms of Service</a></li>
</ul>
</div>

{/* Contact Info */}
<div>
<h3 className="font-semibold text-lg mb-4">Contact Us</h3>
<div className="space-y-3">
<div className="flex items-center space-x-3">
<SafeIcon icon={FiMapPin} className="h-5 w-5 text-blue-400" />
<span className="text-gray-300">Burbank,CA 91501</span>
</div>
<div className="flex items-center space-x-3">
<SafeIcon icon={FiMail} className="h-5 w-5 text-blue-400" />
<span className="text-gray-300">info@burbankinsurance.com</span>
</div>
</div>
</div>

{/* California Locations */}
<div>
<h3 className="font-semibold text-lg mb-4">Serving Los Angeles & All California</h3>
<div className="grid grid-cols-1 gap-1 text-sm">
{mainCities.map(([slug,city])=> (
<Link
key={slug}
to={`/pet-insurance/${slug}`}
className="text-gray-300 hover:text-white"
>
Pet Insurance {city.name}
</Link>
))}
</div>
<div className="mt-2 text-sm text-gray-400">
+ All CA Cities & Counties
</div>
</div>
</div>

<div className="border-t border-gray-700 mt-8 pt-8 text-center">
<p className="text-gray-400 text-sm">
© 2024 Burbank Insurance Services. Licensed insurance agent for Nationwide pet insurance. All rights reserved. CA License #0123456
</p>
</div>
</div>
</footer>
);
};

export default Footer;